import classNames from "classnames/bind";
import styles from "./OnwardLinks.module.scss";
import ButtonCarousel from "@JohnLewisPartnership/jl-design-system/dist/components/button-carousel/ButtonCarousel";
import { OnwardLinksImageCards } from "@/components/OnwardLinks/OnwardLinksImageCards.tsx";
import {
  ONWARD_LINK_CARD_CLICKED_EVENT,
  OnwardLinkType,
} from "@/components/OnwardLinks/OnwardLinks.tsx";
import { dispatchMonetateQEvent } from "@/utils/monetate/monetateQ";

export type OnwardLink = {
  title: string;
  url: string;
  imageUrl?: string;
};

type Props = {
  onwardLinks: OnwardLink[];
  onwardLinkType: OnwardLinkType;
};

export const OnwardLinksUI = ({ onwardLinks, onwardLinkType }: Props) => {
  const cx = classNames.bind(styles);

  const renderOnwardLinks = () => {
    switch (onwardLinkType) {
      case OnwardLinkType.CLIENT_TEXT_LINKS: {
        return (
          <ButtonCarousel
            data-testid="button-carousel"
            ariaLabel="Onward link buttons"
            className={cx(styles.buttonCarousel)}
            buttonList={onwardLinks.map((link) => ({
              buttonText: link.title,
              tag: "button",
              onClick: () => {
                dispatchMonetateQEvent(ONWARD_LINK_CARD_CLICKED_EVENT);
                window.location.href = link.url;
              },
            }))}
          />
        );
      }

      case OnwardLinkType.CLIENT_IMAGE_CARDS:
      default: {
        return <OnwardLinksImageCards onwardLinks={onwardLinks} />;
      }
    }
  };

  return (
    <div className={styles.container} data-component="OnwardLinks">
      <h2>Discover more</h2>
      {renderOnwardLinks()}
    </div>
  );
};
